(function () {
  'use strict';

  /* Current Shopify country, injected server-side. Drives the display currency. */
  var SERVER_COUNTRY = (window.__asteriCurCountry || '').toString().toUpperCase();

  /* ------------------------------------------------------------------ CONFIG */
  var CONFIG = {
    baseCurrency: 'SAR',       // the shop's actual (Shopify) currency — prices render in this
    defaultCurrency: 'USD',    // any country without a specific mapping (international)

    // Rates are SAR -> target multipliers (base = SAR = 1). Gulf pegs are stable;
    // EUR/GBP are approximate cross-rates off the SAR↔USD peg — update to match your
    // Markets rates / a live FX feed whenever you like.
    currencies: {
      SAR: { display: 'SR',  decimals: 2, rate: 1,        symbolFirst: true },
      // priceDisplay '' -> prices print as bare numbers; the official dirham
      // symbol is drawn by CSS (body[data-display-currency='AED'] .price:before).
      AED: { display: 'AED', priceDisplay: '', decimals: 2, rate: 0.9793, symbolFirst: true },
      USD: { display: '$',   decimals: 2, rate: 0.26667,  symbolFirst: true },
      KWD: { display: 'KWD', decimals: 2, rate: 0.08176,  symbolFirst: true },
      BHD: { display: 'BHD', decimals: 2, rate: 0.10027,  symbolFirst: true },
      OMR: { display: 'OMR', decimals: 2, rate: 0.10253,  symbolFirst: true },
      QAR: { display: 'QAR', decimals: 2, rate: 0.97067,  symbolFirst: true },
      EUR: { display: '€',   decimals: 2, rate: 0.24691,  symbolFirst: true },
      GBP: { display: '£',   decimals: 2, rate: 0.20997,  symbolFirst: true }
    },

    // Country ISO (alpha-2) -> display currency. Not listed -> defaultCurrency (USD).
    countryToCurrency: {
      SA: 'SAR', AE: 'AED', KW: 'KWD', BH: 'BHD', OM: 'OMR', QA: 'QAR', US: 'USD',

      // United Kingdom -> pounds
      GB: 'GBP',

      // Europe -> euros. Eurozone members plus (by request) the other European
      // markets you sell to. If you ever want Sweden in SEK or Switzerland in CHF,
      // add those currencies above and remap SE / CH here.
      AT: 'EUR', BE: 'EUR', FR: 'EUR', DE: 'EUR', GR: 'EUR', IE: 'EUR', IT: 'EUR',
      LU: 'EUR', NL: 'EUR', PT: 'EUR', ES: 'EUR', FI: 'EUR', CY: 'EUR', MT: 'EUR',
      SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR', HR: 'EUR',
      SE: 'EUR', CH: 'EUR'
    }
  };

  function currencyForCountry(iso) {
    var code = CONFIG.countryToCurrency[iso];
    return (code && CONFIG.currencies[code]) ? code : CONFIG.defaultCurrency;
  }

  /* Outermost price containers. We walk their text-nodes; we never flatten them. */
  var PRICE_SELECTORS = [
    '.price', '.price-item', '.price-item--regular', '.price-item--sale',
    '.compare-at-price', '.unit-price', '.money',
    '.cart-item__price', '.cart-item__total', '.cart-item__old-price',
    '.totals__subtotal-value', '.totals__total', '.cart__total-value',
    '[data-price]'
  ].join(',');

  /* Leftover BASE (SAR) currency symbol representations to blank out.
     Covers the old ﷼ (U+FDFC), the new Saudi Riyal sign (U+20C0), ر.س, ريال, SR, SAR. */
  var BASE_SYMBOL_RE = /﷼|⃀|₨|ر\s*\.?\s*س\.?|ريال|\bSR\b|\bSAR\b/i;

  /* A text node counts as a stray currency symbol if it has NO digits and is either
     a known base symbol OR a short non-separator token (currency glyph / ISO code).
     Range/separator glyphs ( -  –  /  , ) are preserved. */
  function isStraySymbol(t) {
    if (!t || /[0-9٠-٩]/.test(t)) return false;
    var trimmed = t.replace(/\s+/g, '');
    if (!trimmed || /^[-–—\/.,]+$/.test(trimmed)) return false;
    return BASE_SYMBOL_RE.test(t) || trimmed.length <= 3;
  }

  /* --------------------------------------------------------------- UTILITIES */

  function parseAmount(text) {
    if (!text || !/[0-9٠-٩]/.test(text)) return null;
    var s = text.replace(/[٠-٩]/g, function (d) { return d.charCodeAt(0) - 0x0660; });
    s = s.replace(/[^0-9.,٫٬]/g, '')
         .replace(/٫/g, '.').replace(/٬/g, ',')
         .replace(/^[.,\s]+/, '').replace(/[.,\s]+$/, '');
    if (!s) return null;
    var lastDot = s.lastIndexOf('.');
    var lastComma = s.lastIndexOf(',');
    var decimalSep = (lastDot === -1 && lastComma === -1) ? null : (lastDot > lastComma ? '.' : ',');
    var intPart, fracPart = '';
    if (decimalSep) {
      var idx = s.lastIndexOf(decimalSep);
      intPart = s.slice(0, idx).replace(/[.,\s]/g, '');
      fracPart = s.slice(idx + 1).replace(/[^0-9]/g, '');
    } else {
      intPart = s.replace(/[.,\s]/g, '');
    }
    if (!intPart && !fracPart) return null;
    var num = parseFloat((intPart || '0') + '.' + (fracPart || '0'));
    return isNaN(num) ? null : num;
  }

  /* 1 amount, or 2 for a "min - max" range inside a single text node. */
  function extractAmounts(text) {
    var parts = text.split(/\s[-–—]\s/);
    if (parts.length === 2) {
      var a = parseAmount(parts[0]), b = parseAmount(parts[1]);
      if (a !== null && b !== null) return [a, b];
    }
    var single = parseAmount(text);
    return single === null ? [] : [single];
  }

  function formatMoney(amount, cur) {
    var c = CONFIG.currencies[cur], num;
    try {
      num = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: c.decimals, maximumFractionDigits: c.decimals
      }).format(amount);
    } catch (e) { num = amount.toFixed(c.decimals); }
    var label = (c.priceDisplay === undefined) ? c.display : c.priceDisplay;
    if (!label) return num;
    return c.symbolFirst ? (label + ' ' + num) : (num + ' ' + label);
  }

  /* ---------------------------------------------------------- CONVERSION CORE */

  var current = currencyForCountry(SERVER_COUNTRY);
  var rate = CONFIG.currencies[current].rate;

  /* Expose the active DISPLAY currency on <body> so CSS can draw currency symbols
     (e.g. the official AED dirham glyph). body[data-currency] stays the Shopify
     currency (always SAR here); this is the one shoppers actually see. */
  function reflectBodyCurrency() {
    if (!document.body) return;
    document.body.setAttribute('data-display-currency', current);
    document.body.classList.toggle('currency-aed', current === 'AED');
  }
  reflectBodyCurrency();

  var seen = new WeakMap();   // priceNode -> lastOut textContent (skip if unchanged)
  var observer = null;

  function collectPriceNodes(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    var matched = Array.prototype.slice.call(scope.querySelectorAll(PRICE_SELECTORS));
    if (root && root.matches && root.matches(PRICE_SELECTORS)) matched.push(root);
    // outermost only (no matched ancestor), so each number is handled once
    return matched.filter(function (el) {
      var p = el.parentElement;
      return !(p && p.closest(PRICE_SELECTORS));
    });
  }

  function textNodesIn(el) {
    var out = [], w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) out.push(n);
    return out;
  }

  function blankBaseSymbols(el) {
    // 1) stray symbol-only text nodes ("﷼", the new SAR glyph, "SR", "ر.س", …)
    textNodesIn(el).forEach(function (n) {
      if (isStraySymbol(n.nodeValue)) n.nodeValue = '';
    });
    // 2) symbol elements: svg / img / <use> glyphs, or spans flagged as a currency symbol
    el.querySelectorAll('svg,img,use,[class*="currency" i],[class*="symbol" i],[class*="riyal" i],[class*="sar" i]').forEach(function (sym) {
      if (!/[0-9٠-٩]/.test(sym.textContent || '')) sym.remove();
    });
  }

  function processPriceNode(el) {
    var curText = el.textContent;
    if (!curText || !/[0-9٠-٩]/.test(curText)) return;
    if (seen.get(el) === curText) return;                 // already ours, unchanged

    var numberNodes = textNodesIn(el).filter(function (n) {
      return /[0-9٠-٩]/.test(n.nodeValue);
    });
    if (!numberNodes.length) return;

    blankBaseSymbols(el);                                 // drop the old symbol(s)

    numberNodes.forEach(function (tn) {
      var amounts = extractAmounts(tn.nodeValue);
      if (!amounts.length) return;
      tn.nodeValue = amounts.map(function (b) { return formatMoney(b * rate, current); }).join(' - ');
    });

    if (el.classList) el.classList.add('asteri-cur-x');   // enables the ::before override
    seen.set(el, el.textContent);
  }

  /* Belt-and-suspenders: if the base symbol is drawn via a CSS ::before/::after
     (a background-image or content glyph) rather than a DOM node, hide it on
     converted prices. Scoped tightly to the price element and its money/symbol bits. */
  function injectCss() {
    if (document.getElementById('asteri-cur-style')) return;
    var s = document.createElement('style');
    s.id = 'asteri-cur-style';
    s.textContent =
      '.asteri-cur-x::before,.asteri-cur-x::after,' +
      '.asteri-cur-x .money::before,.asteri-cur-x .money::after,' +
      '.asteri-cur-x [class*="currency" i]::before,.asteri-cur-x [class*="symbol" i]::before,' +
      '.asteri-cur-x [class*="riyal" i]::before,.asteri-cur-x [class*="sar" i]::before' +
      '{content:none !important;background-image:none !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  function convertAll(root) {
    if (current === CONFIG.baseCurrency) return;          // SAR: leave native prices untouched
    if (observer) observer.disconnect();                  // never observe our own writes
    collectPriceNodes(root).forEach(processPriceNode);
    reflectLabels();
    if (observer) startObserver();
  }

  function reflectLabels() {
    var label = CONFIG.currencies[current].display;
    document.querySelectorAll('[data-asteri-current-currency]').forEach(function (el) {
      if (el.textContent !== label) el.textContent = label;
    });
  }

  /* --------------------------------------------------------------- OBSERVER */

  var scheduled = false;
  function scheduleConvert() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; convertAll(document); });
  }
  function startObserver() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    reflectBodyCurrency();
    if (current === CONFIG.baseCurrency) return;          // nothing to do for SAR
    injectCss();
    convertAll(document);
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if ((m.addedNodes && m.addedNodes.length) || m.type === 'characterData') { scheduleConvert(); return; }
      }
    });
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Debug / manual override (does not persist — currency follows the country). */
  window.AsteriCurrency = {
    get: function () { return current; },
    country: function () { return SERVER_COUNTRY; },
    setForCountry: function (iso) {
      current = currencyForCountry((iso || '').toString().toUpperCase());
      rate = CONFIG.currencies[current].rate; seen = new WeakMap();
      reflectBodyCurrency(); convertAll(document);
    },
    set: function (code) {
      if (!CONFIG.currencies[code]) return;
      current = code; rate = CONFIG.currencies[code].rate; seen = new WeakMap();
      reflectBodyCurrency(); convertAll(document);
    },
    convert: function () { seen = new WeakMap(); convertAll(document); },
    config: CONFIG
  };
})();
